import React from 'react';
import { ServiceLandingPage } from '../components/ServiceLandingPage';
export function PortfolioStrategy() {
  return <ServiceLandingPage badge="Portfolio Strategy" heroHeadline="Structure Your Portfolio for Long-Term Growth" heroSub="If your loans aren't structured properly, your growth is limited." heroCta="Book a Strategy Session" problems={['Multiple properties but no strategy', 'Cross-collateralisation issues', 'Equity locked', 'Cashflow vs growth confusion']} videoSectionTitle="Advanced Strategy Series" videos={[{
    title: 'Loan structuring deep dive',
    id: 'dQw4w9WgXcQ'
  }, {
    title: 'Portfolio mistakes',
    id: 'dQw4w9WgXcQ'
  }, {
    title: 'Scaling strategies',
    id: 'dQw4w9WgXcQ'
  }]} howWeHelp={['Restructure', 'Optimise lending', 'Unlock flexibility']} process={[{
    title: 'Deep portfolio review',
    description: 'Analyze every loan, rate, and structure.'
  }, {
    title: 'Identify inefficiencies',
    description: 'Find locked equity and poor setups.'
  }, {
    title: 'Restructure loans',
    description: 'Untangle cross-collateralisation.'
  }, {
    title: 'Align with long-term goals',
    description: 'Ensure the setup supports your end game.'
  }]} scenario="Client restructured portfolio → unlocked borrowing capacity" finalCta="Fix Your Structure" data-id="element-1622" />;
}